#import "./confluence-comment-fragment.graphql"

query CommentCount(
  $offset: String
  $last: Long
  $contentId: ID!
  $commentId: ID
  $inlineMarkerRef: String
) {
  comments(
    pageId: $contentId
    last: $last
    after: $offset
    contentStatus: [CURRENT]
    depth: ROOT
    # The type field below is an array which performs an OR operation on its elements
    type: [UNRESOLVED]
    commentId: $commentId
    inlineMarkerRef: $inlineMarkerRef
  ) {
    totalCount
    __typename
  }
}
